.k9{gap:0.125rem;}